/**
 * @generated SignedSource<<198efc8c940bdde8dcca6679f231b9f1>>
 * @relayHash ec5078a7a8707ac706a1d2f10a2f500b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 38eacd707aa77f40219d79a994d99bf838781fd5a342a13dc46377e16028307f

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ProjectAccessPermissionsSettingsAggQuery$variables = {
  containerId: string;
  isDefaultAccessLevelEnabled: boolean;
  isM3GroupPermsEnabled: boolean;
};
export type ProjectAccessPermissionsSettingsAggQuery$data = {
  readonly DefaultProjectAccessLevelSection?: {
    readonly " $fragmentSpreads": FragmentRefs<"DefaultProjectAccessLevelSection">;
  } | null;
  readonly ProjectGroupPermissionsSettings?: {
    readonly " $fragmentSpreads": FragmentRefs<"ProjectGroupPermissionsSettings">;
  } | null;
};
export type ProjectAccessPermissionsSettingsAggQuery = {
  response: ProjectAccessPermissionsSettingsAggQuery$data;
  variables: ProjectAccessPermissionsSettingsAggQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isDefaultAccessLevelEnabled"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isM3GroupPermsEnabled"
},
v3 = {
  "kind": "Variable",
  "name": "containerId",
  "variableName": "containerId"
},
v4 = [
  (v3/*: any*/)
],
v5 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ProjectAccessPermissionsSettingsAggQuery",
    "selections": [
      {
        "condition": "isDefaultAccessLevelEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "args": (v4/*: any*/),
                  "kind": "FragmentSpread",
                  "name": "DefaultProjectAccessLevelSection"
                }
              ],
              "type": "Query"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "DefaultProjectAccessLevelSection"
          }
        ]
      },
      {
        "condition": "isM3GroupPermsEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "args": (v4/*: any*/),
                  "kind": "FragmentSpread",
                  "name": "ProjectGroupPermissionsSettings"
                }
              ],
              "type": "Query"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "ProjectGroupPermissionsSettings"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "ProjectAccessPermissionsSettingsAggQuery",
    "selections": [
      {
        "condition": "isDefaultAccessLevelEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v4/*: any*/),
            "concreteType": "TownsquareProjectsAppSettings",
            "kind": "LinkedField",
            "name": "projects_appSettings",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "defaultProjectAccessLevel"
              }
            ]
          }
        ]
      },
      {
        "condition": "isM3GroupPermsEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v4/*: any*/),
            "concreteType": "TownsquareProjectAppCapabilities",
            "kind": "LinkedField",
            "name": "projects_capabilities",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "canRemoveAppLevelPermissions"
              }
            ]
          },
          {
            "args": [
              (v3/*: any*/),
              {
                "kind": "Literal",
                "name": "first",
                "value": 100
              }
            ],
            "concreteType": "TownsquareProjectsAppPermissionPolicyConnection",
            "kind": "LinkedField",
            "name": "projects_appPermissionPolicies",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareProjectsAppPermissionPolicyEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareProjectsAppPermissionPolicy",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "scopedGroupId"
                      },
                      {
                        "concreteType": "IdentityGroup",
                        "kind": "LinkedField",
                        "name": "group",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "name"
                          },
                          (v5/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isDefaultGroup"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isEditable"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "userCount"
                      },
                      {
                        "concreteType": "TownsquareProductRole",
                        "kind": "LinkedField",
                        "name": "productRoles",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "role"
                          }
                        ]
                      },
                      {
                        "concreteType": "TownsquareProjectsAppPermissionEntry",
                        "kind": "LinkedField",
                        "name": "appPermissions",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "permission"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "isPermitted"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "ec5078a7a8707ac706a1d2f10a2f500b",
    "id": "38eacd707aa77f40219d79a994d99bf838781fd5a342a13dc46377e16028307f",
    "metadata": {},
    "name": "ProjectAccessPermissionsSettingsAggQuery",
    "operationKind": "query",
    "text": "query ProjectAccessPermissionsSettingsAggQuery(\n  $containerId: ID!\n  $isM3GroupPermsEnabled: Boolean!\n  $isDefaultAccessLevelEnabled: Boolean!\n) {\n  ...DefaultProjectAccessLevelSection_1GKbF9 @include(if: $isDefaultAccessLevelEnabled)\n  ...ProjectGroupPermissionsSettings_1GKbF9 @include(if: $isM3GroupPermsEnabled)\n}\n\nfragment DefaultProjectAccessLevelSection_1GKbF9 on Query {\n  projects_appSettings(containerId: $containerId) @optIn(to: \"Townsquare\") {\n    defaultProjectAccessLevel\n  }\n}\n\nfragment ProjectGroupPermissionsSettings_1GKbF9 on Query {\n  projects_capabilities(containerId: $containerId) {\n    canRemoveAppLevelPermissions\n  }\n  projects_appPermissionPolicies(containerId: $containerId, first: 100) @optIn(to: \"Townsquare\") {\n    edges {\n      node {\n        id\n        scopedGroupId\n        group {\n          name\n          id\n        }\n        isDefaultGroup\n        isEditable\n        userCount\n        productRoles {\n          role\n        }\n        appPermissions {\n          permission\n          isPermitted\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6172e2435d253819b0a13abc4d4b1eb8";

export default node;
